export enum CraftingModeActionTypes {
  CRAFTING = 'crafting-mode/CRAFTING',
  CRAFTED = 'crafting-mode/CRAFTED',
  DISENCHANTING = 'crafting-mode/DISENCHANTING',
  DISENCHANTED = 'crafting-mode/DISENCHANTED',
}
